var _path, _path2, _path3, _path4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAccessDenied = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 280,
  height: 280,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("rect", {
  width: 86.723,
  height: 61,
  x: 84.725,
  y: 84.75,
  fill: "#E0D3FF",
  rx: 4,
  style: {
    mixBlendMode: "multiply"
  }
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#5F249F",
  d: "M124.61 100.558c1.56-2.71 5.46-2.71 7.02 0l15.355 26.681c1.56 2.711-.39 6.099-3.509 6.099h-30.711c-3.12 0-5.07-3.388-3.51-6.099z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FAF8FF",
  d: "M126.175 109.021h3.892l-.721 13.045h-2.45zm-.086 17.403q0-.776.576-1.283.606-.508 1.47-.508.865 0 1.442.508.576.507.576 1.283t-.576 1.31q-.577.508-1.442.508-.864 0-1.47-.508a1.72 1.72 0 0 1-.576-1.31"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#2D2D2D",
  d: "M207.834 104.332c12.946 0 23.44 10.527 23.44 23.514a23.52 23.52 0 0 1-12.592 20.849c-.908.477-1.397 1.52-1.091 2.499l12.876 41.17a2 2 0 0 1-1.909 2.597h-41.44a2 2 0 0 1-1.908-2.597l12.874-41.167c.306-.979-.183-2.022-1.091-2.498-7.488-3.926-12.599-11.79-12.599-20.853 0-12.987 10.494-23.514 23.44-23.514"
})), /*#__PURE__*/React.createElement("mask", {
  id: "accessDenied_svg__a",
  width: 184,
  height: 112,
  x: 48,
  y: 84,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "m209.725 126.25 21.5 69h-182.5V84.75h147.5z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#accessDenied_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#E0D3FF",
  strokeWidth: 8,
  d: "M128.225 141.75v19.5a8 8 0 0 0 8 8h89.5"
}))));
export { SvgAccessDenied as ReactComponent };
export default __webpack_public_path__ + "static/media/accessDenied.7d4fc3c3.svg";